import { uiTokens } from '@/theme/uiTokens';
import {
  BlockOutlinedIcon,
  CancelOutlinedIcon,
  CheckCircleOutlineIcon,
  DonutLargeIcon,
  EditOutlinedIcon,
  ErrorOutline,
  EventAvailableOutlinedIcon,
  EventBusyOutlinedIcon,
  EventOutlinedIcon,
  HelpOutline,
  PlayCircleFilledWhiteOutlinedIcon,
  ReleasesIcon,
  ScheduleOutlinedIcon,
} from '@/ui/primitives/icons';
import { getStatusChipColor, type StatusChipStatus } from '@/ui/primitives/statusChips';
import type { SvgIconComponent } from '@/ui/primitives';

type StatusFilterOptionIcon = {
  countIcon: SvgIconComponent;
  countIconColor: string;
};

const resolveStatusFilterIcon = (status: string): SvgIconComponent => {
  if (status === 'draft') return EditOutlinedIcon;
  if (status === 'planned') return EventOutlinedIcon;
  if (status === 'ready') return EventAvailableOutlinedIcon;
  if (status === 'overdue') return EventBusyOutlinedIcon;
  if (status === 'released') return ReleasesIcon;
  if (status === 'passed' || status === 'completed' || status === 'success') {
    return CheckCircleOutlineIcon;
  }
  if (status === 'failed') return CancelOutlinedIcon;
  if (status === 'errored') return ErrorOutline;
  if (status === 'running') return PlayCircleFilledWhiteOutlinedIcon;
  if (status === 'queued') return ScheduleOutlinedIcon;
  if (status === 'skipped') return BlockOutlinedIcon;
  if (status === 'untested') return HelpOutline;
  return DonutLargeIcon;
};

const resolveStatusFilterIconColor = (status: string): string =>
  uiTokens.statusColors[getStatusChipColor(status as StatusChipStatus)];

export const withStatusFilterOptionIcons = <TOption extends { value: string }>(
  options: readonly TOption[],
): Array<TOption & StatusFilterOptionIcon> =>
  options.map((option) => ({
    ...option,
    countIcon: resolveStatusFilterIcon(option.value),
    countIconColor: resolveStatusFilterIconColor(option.value),
  }));
